module.exports = __webpack_public_path__ + "img/56.49d7e60.jpg";